
import { Component, Vue, Watch } from 'vue-property-decorator'

import BacLoggedInHeader from '@/templates/BacLoggedInHeader.vue'
import BacButton from '@/components/BacButton.vue'
import BacModal from '@/components/BacModal.vue'
import BacInput from '@/components/BacInput.vue'
import BacTextarea from '@/components/BacTextarea.vue'
import CustomerPermissionsModal from '@/components/admin/customer/CustomerPermissionsModal.vue'
import CustomerNoteModal from '@/components/admin/customer/CustomerNoteModal.vue'

import { User } from '@/lib/models/User'

import sanitizeHtml from 'sanitize-html'
import UIkit from 'uikit'
import { RallyRound } from '../../lib/models/RallyRound'
import { Rally } from '../../lib/models/Rally'
import { DateUtils } from '@/lib/utils/DateUtils'
import { Country } from '../../lib/models/Country'

@Component({
  components: {
    BacLoggedInHeader,
    BacButton,
    BacModal,
    BacInput,
    BacTextarea,
    CustomerPermissionsModal,
    CustomerNoteModal
  }
})
export default class CustomerSearch extends Vue {
  search = ''
  searchResults: User[] = []
  sanitizeHtml = sanitizeHtml
  passwordChangeCustomerId = -1
  newPassword = ''

  editedCustomerId = -1

  newCustomerGroupId = -1
  selectedPermissionRallyRounds = []

  countries: Country[] = []
  User = User

  get editedUser () {
    return this.searchResults.find(user => user.id === this.editedCustomerId) ?? new User()
  }

  get passwordChangeUser () {
    return this.searchResults.find(user => user.id === this.passwordChangeCustomerId) ?? new User()
  }

  headers = [
    { text: 'Name', value: 'name', width: 80 },
    { text: 'Startnummer', value: 'startnumber', width: 15 },
    { text: 'Teams', value: 'teams', width: 100 },
    { text: 'Runden', value: 'rounds', width: 100 },
    { text: 'E-Mail', value: 'email', width: 30 },
    { text: 'Telefonnummer', value: 'telephone', width: 30 },
    { text: 'Geburtstag', value: 'birthday', width: 30 },
    { text: 'Adresse', value: 'address', width: 30 },
    { text: 'Passwort ändern', value: 'password', width: 30 },
    { text: 'Notiz', value: 'annotiation', width: 100 },
    { text: 'Haftungsausschluss bestätigt', value: 'liabilitySigned', width: 100 }
  ]

  get headersWithPermissions () {
    if (this.$store.state.LoggedInUser.user && !this.$store.state.LoggedInUser.user.isAdmin) {
      return this.headers
    }
    // special admin columns
    return [...this.headers,
      { text: 'Berechtigungen', value: 'permissions', width: 30 }
    ]
  }

  get items () {
    return this.searchResults.map(user => {
      const name = user.firstname || user.lastname ? user.firstname + ' ' + user.lastname : 'Kein Name angegeben'
      const id = user.id ? user.id.toString() : '-'

      let startnumber = '-'
      let team = '-'
      if (user.teams && user.teams.length) {
        // add # before number and only map from team to only starnumbers
        let startnumbers = user.teams.map(team => `#${team.number}`)
        // map team to team name
        let teams = user.teams.map(team => team.name ?? '-')
        // remove duplicates in cool ES6 way https://www.samanthaming.com/tidbits/43-3-ways-to-remove-array-duplicates/
        startnumbers = startnumbers.filter((number, i) => startnumbers.indexOf(number) === i)
        teams = teams.filter((name, i) => teams.indexOf(name) === i)

        startnumber = startnumbers.join(', ')
        team = teams.join('<br>')
      }

      let rounds = '-'
      if (user.rounds && user.rounds.length) {
        rounds = user.rounds.map(round => {
          if ((round as any).ranking) {
            return round.name + '🏆' + (round as any).ranking
          }
          return round.name
        }).join('<br>')
      }

      const email = user.email || '-'
      const telephone = user.telephone || '-'
      const address = user.street || user.zip || user.city ? `${user.street}<br>${user.zip} ${user.city}` : '-'
      const annotiation = user.notes.length ? user.notes.map(note => note.note).join('\n') : '-'
      let birthday = '-'
      if (user.birthday) {
        birthday = DateUtils.isoToMysql(user.birthday.replace(/-/g, '/').replace(/T.+/, '')).split(' ')[0]
      }

      const liabilitySigned = user.liabilitiesSigned

      return { id, name, startnumber, email, teams: team, telephone, birthday, address, annotiation, rounds, liabilitySigned }
    })
  }

  allRallyRounds: {id: number; name: string; rallyId: number}[] = []
  filterRallyRoundId = this.filterableRoundOptions && this.filterableRoundOptions.length ? this.filterableRoundOptions[0].id : -1
  filterRallyId = this.filterableRallies[0].id

  /**
   * ID -1 = not loaded
   * ID 0 = All Rounds
   * Otherwise ID = rally_round_id
   */
  get filterableRoundOptions () {
    if (!this.$store.state.LoggedInUser.user) {
      return [
        { name: '', id: -1, rallyId: -1 }
      ]
    }
    if (this.$store.state.LoggedInUser.user.isAdmin) {
      return [{ name: 'Alle Runden', id: 0, rallyId: -1 }, ...this.allRallyRounds]
    }
    return this.allRallyRounds
  }

  get filterableRoundOptionsFilteredByRally () {
    return this.filterableRoundOptions.filter(rallyRound => {
      return rallyRound.rallyId === this.filterRallyId
    })
  }

  /**
   * ID -1 = not loaded
   * ID 0 = All Rallies
   * Otherwise ID = rally__id
   */
  get filterableRallies () {
    return [
      { name: 'Alle Rallys', id: 0 },
      ...this.$store.state.Rally.rallies
    ]
  }

  /* get birthday () {
    const date = new Date(this.editedUser.birthday as any)
    date.setDate(date.getDate() + 1)
    return date.toISOString().split('T')[0]
  } */

  /* set birthday (birthday: string) {
    this.editedUser.birthday = birthday
  } */

  @Watch('filterRallyId')
  onFilterRallyIdChange () {
    this.filterRallyRoundId = this.filterableRoundOptions[0].id
  }

  mounted () {
    this.searchCustomers()
    this.$store.dispatch('loadLoggedInUser')
    this.loadAdminPermissionRallyRounds()
    this.loadRallies()
    this.loadCountries()
  }

  @Watch('filterRallyRoundId')
  onFilterRallyRoundIdChanged () {
    this.searchCustomers()
  }

  async loadRallies () {
    this.$store.dispatch('loadRallies')
  }

  private async loadAdminPermissionRallyRounds () {
    const allPermittedRounds = await RallyRound.getAll({ params: ['admin-permission'] })
    this.allRallyRounds = allPermittedRounds.map((rallyRound: RallyRound) => {
      return { id: rallyRound.id, name: rallyRound.name, rallyId: rallyRound.rallyId }
    })
    this.filterRallyRoundId = this.filterableRoundOptions[0].id
  }

  private searchTimeout = 0;
  @Watch('search')
  onSearchChanged () {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout)
    }
    this.searchTimeout = setTimeout(this.searchCustomers, 500)
  }

  async loadCountries () {
    this.countries = await Country.getAll({})
  }

  async searchCustomers () {
    if (this.filterRallyRoundId > 0) {
      this.searchResults = await User.searchForRallyRound(this.search, this.filterRallyRoundId)
      return
    }
    this.searchResults = await User.search(this.search)
  }

  async changePassword () {
    await this.passwordChangeUser.changePassword(this.newPassword)
    this.newPassword = ''
    UIkit.notification({
      message: 'Passwort erfolgreich geändert',
      status: 'success',
      timeout: 5000,
      pos: 'bottom-center'
    })
  }

  async updateEditedUser () {
    await this.editedUser.update()
    UIkit.notification({
      message: 'Teilnehmer geupdated!',
      status: 'success',
      timeout: 5000,
      pos: 'bottom-center'
    })
  }

  async downloadCSV () {
    if (this.filterRallyRoundId <= 0) {
      UIkit.modal('#waiting-for-download-modal').show()
    }
    RallyRound.downloadCustomersCSV(this.filterRallyRoundId)
  }
}

